import { ManualPowerProfile } from 'features/blueprints/hooks/useUpdateBlueprint/types';
import { powerProfileModes } from 'greener-ui-library';
import { projectTypeStringToId } from 'pages/Blueprints/components/utils';
import { BlueprintFormData } from '../types';
import { buildCalculations } from './buildCalculations';
import { daysToIndices } from './sortDays';

export const buildUpdatePayload = (formData: BlueprintFormData) => {
  const calculations = buildCalculations(formData);

  let powerProfileCsv: File | undefined;
  let manualPowerProfileData: ManualPowerProfile | undefined;

  if (formData.powerProfileMode === powerProfileModes.manual && formData.averagePowerKw !== undefined) {
    manualPowerProfileData = {
      active_days: daysToIndices(formData.workingDays ?? []),
      active_period_peak_power_kw: formData.peakPowerKw ?? 0,
      active_period_average_power_kw: formData.averagePowerKw ?? 0,
      active_period_start_time: formData.workingHoursStart ?? '00:00',
      active_period_end_time: formData.workingHoursEnd ?? '00:00',
      peaks_per_active_period: formData.peaksPerDay ?? 0,
      peaks_duration_seconds: formData.peaksDuration ?? 0,
      idle_period_average_power_kw: formData.restDayAveragePowerKw ?? 0,
    };
  } else if (formData.powerProfileMode !== powerProfileModes.manual) {
    const editedCsvData = formData.editedPowerProfileCsv || formData.rawPowerProfileCsv;
    if (editedCsvData) {
      // Always use text/csv MIME type - backend processes all file types and returns CSV
      const fileName = formData.originalFileName ? `edited-${formData.originalFileName}` : 'edited-power-profile.csv';
      const mimeType = 'text/csv';
      const csvBlob = new Blob([editedCsvData], { type: mimeType });
      powerProfileCsv = new File([csvBlob], fileName, { type: mimeType });
    }
  }

  return {
    name: formData.blueprintName,
    client_name: formData.clientName,
    partner_organisation_id: formData.partnerOrganisationId ?? null,
    ts_start: formData.startDate instanceof Date ? formData.startDate.toISOString() : new Date().toISOString(),
    ts_end: formData.endDate instanceof Date ? formData.endDate.toISOString() : null,
    project_type_id: formData.applicationType ? projectTypeStringToId(formData.applicationType) : -1,
    hybrid_reasons: [
      ...(formData.hybridReasons ?? []),
      ...(formData.hybridReasonsCustom?.trim() ? [formData.hybridReasonsCustom.trim()] : []),
    ],
    calculations,
    ...((manualPowerProfileData || powerProfileCsv) && { power_profile_create_mode: formData.powerProfileMode }),
    ...(powerProfileCsv && { power_profile_csv: powerProfileCsv }),
    ...(manualPowerProfileData && { power_profile_generation_data: manualPowerProfileData }),
  };
};
